"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMOTE_ACCESS_CONNECTIONS_LIMIT = void 0;
exports.REMOTE_ACCESS_CONNECTIONS_LIMIT = {
    Lan: {
        lite: 1,
        plus_v2: 2,
        /** @deprecated */ pro: 1,
        pro_v2: 3,
        /** @deprecated */ premium: 3,
        premium_v2: 5,
        /** @deprecated */ ultimate: Infinity,
        ultimate_v2: Infinity,
    },
    Internet: {
        lite: 0,
        plus_v2: 0,
        /** @deprecated */ pro: 1,
        pro_v2: 1,
        /** @deprecated */ premium: 3,
        premium_v2: 3,
        /** @deprecated */ ultimate: Infinity,
        ultimate_v2: Infinity,
    },
};
//# sourceMappingURL=remoteAccess.js.map